import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { selectCompany } from 'src/old/actions/company/companySelectors';
import { helpBarData } from './helpData';
import HelpBar from './index';

const useStyles = makeStyles(theme => ({
  root: {
    margin: '0 auto',
    paddingTop: theme.spacing(4.5),
    [theme.breakpoints.up('sm')]: {
      minHeight: '780px'
    }
  }
}));

const WithHelpBar = ({ children, helpBarData: customHelpBarData, hide = false }) => {
  const classes = useStyles();
  const currentCompany = useSelector(selectCompany);

  return (
    <Grid container xs={12} classes={{ root: classes.root }} spacing={4}>
      <Grid item xs={12} lg={hide ? 12 : 9} style={{ paddingLeft: 0 }}>
        {children}
      </Grid>

      {!hide && (
        <Grid item xs={12} lg={3}>
          <HelpBar helpBarData={customHelpBarData || helpBarData(currentCompany?.locale)} />
        </Grid>
      )}
    </Grid>
  );
};

WithHelpBar.propTypes = {
  children: PropTypes.element,
  helpBarData: PropTypes.array,
  hide: PropTypes.bool
};

export default WithHelpBar;
